if (!customElements.get('hp-usp-bar')) {
  class HpUspBar extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('.usp-bar__slide'));
      this.checkScrolling();
      window.addEventListener('resize', this.checkScrolling.bind(this));
    }

    checkScrolling() {
      this.setAttribute('data-animated', 'false');
      this.slides.forEach((slide) => {
        if (slide.getClientRects()[0].x < 10 || slide.getClientRects()[0].x > window.innerWidth) {
          this.startAnimation();
        }
      });
    }

    startAnimation() {
      if (this.getAttribute('data-dublicated') != 'true') {
        this.slides.forEach((slide) => {
          const dublicatedSlide = slide.cloneNode(true);
          dublicatedSlide.setAttribute('aria-hidden', true);
          dublicatedSlide.classList.add('usp-bar__slide--dublicated');
          this.appendChild(dublicatedSlide);
        });
      }
      this.setAttribute('data-animated', 'true');
      this.setAttribute('data-dublicated', 'true');
    }
  }

  customElements.define('hp-usp-bar', HpUspBar);
}
